import { Pricing } from "../pricingListSlice";

export const getPricingType = (pricing?: Pricing) => {
	if (!pricing) return "-";
	if (pricing.is_financial) {
		return pricing.aggregated_pricing_type_name;
	}
	return pricing?.pricing_type?.display_name;
};
